module.exports = __webpack_public_path__ + "static/media/crane.067af025.svg";